import React, {Component} from 'react'
import * as firebase from 'firebase'

import Head from '../components/Head'
import LandingPageAbout from '../components/LandingPageAbout'
import LandingPageLearnMore from '../components/LandingPageLearnMore'
import LandingPageEmployers from '../components/LandingPageEmployers'
import LandingPageNetworkers from '../components/LandingPageNetworkers'
// import LandingPageDemo from '../components/LandingPageDemo'
import LandingPageSpacer from '../components/LandingPageSpacer'
import LandingPageContact from '../components/LandingPageContact'
// import Footer from '../components/Footer'

import {bgWhite,Title,} from '../helper/consts'

const style = {
  container:{
    backgroundColor:bgWhite,
    maxWidth: '100vw',
  },
}

export default class About extends Component{
  componentDidMount(){
    firebase.auth().onAuthStateChanged(user=>{
      if(user){
        if(window.location.hash==='#/About'){
          this.props.history.push('/')
        }
      }
    })
  }
  render(){
    console.log(window.location);
    return (
      <React.Fragment>
        <Head title={`About | ${Title}`} />
        <div style={style.container}>
          <LandingPageAbout />
          <LandingPageSpacer flip={true} />
          <LandingPageEmployers />
          <LandingPageSpacer />
          <LandingPageNetworkers />
          <LandingPageSpacer flip={true} />
          <LandingPageLearnMore />
          <LandingPageSpacer />
          <LandingPageContact />
          <LandingPageSpacer flip={true} />
        </div>
      </React.Fragment>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/About.js